import { render, staticRenderFns } from "./TableOverview.vue?vue&type=template&id=72118a8d"
import script from "./TableOverview.js?vue&type=script&lang=js&external"
export * from "./TableOverview.js?vue&type=script&lang=js&external"
import style0 from "./TableOverview.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports